<template>
    <div class="bar bg_fff">
        <v-title title="今日网络门诊">
            <el-button size="mini" round type="primary">进入网络诊间</el-button>
        </v-title>
        <div class="main">
            <v-chart :options="options"></v-chart>
        </div>
    </div>
</template>

<script>
  import {timeFormat} from "../../lib/utils";
  import VTitle from "../common/v-title";
  import {MAIN_COLOR} from "../../lib/config";

  export default {
    name: 'home-online-bar',
    data() {
      return {
        options: {
          tooltip: {
            trigger: 'axis'
          },
          color: [MAIN_COLOR],
          grid: {
            top: 30,
            bottom: 30,
            left: '5%',
            right: 30
          },
          xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            barWidth: 30,
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar'
          }]
        }
      }
    },
    computed: {},
    components: {VTitle},
    mixins: [],
    created() {

    },
    mounted() {
      setTimeout(this.getData, 2000);
    },
    beforeDestroy() {

    },
    methods: {
      handler() {
        this.$router.push('/main/online');
      },
      getData() {
        const now = Date.now();
        let cate = [], data = [];
        for (let i = 0; i < 15; i++) {
          cate.push(timeFormat(now + i * 24 * 3600 * 1000, '%m-%d'));
          data.push(Math.round(Math.random() * 100));
        }
        this.options.xAxis.data = cate;
        this.options.series = [{
          data: data,
          type: 'bar'
        }];
      }
    }
  }
</script>

<style scoped>
    .main {
        height: 200px;
    }

    .main >>> .echarts {
        width: 100%;
        height: 100%;
    }
</style>
